var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu is-flex"},[_c('div',{staticClass:"menu-inner is-flex middle"},[_c('MenuItems'),_c('Locations')],1),_c('LocationImage'),_c('SocialLinks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }